<!-- Do not change this file. -->
<template>
  <div>
    [[{{ contentLoaded }}]]
    <AlertLoading class="mt-5" v-if="!isReady" />
    <div v-else class="h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import {
  mapState as mapStatePinia,
  mapActions as mapActionsPinia
} from "pinia";
import { readEntry, readEntries } from "@/apis/datastore.js";
import { useContentStore } from "@/dev/store/useContentStore.js";
import { loadContent } from "@/helpers/content.js";
import AlertLoading from "@/components/core/AlertLoading.vue";

export default {
  name: "APIHandler",
  components: {
    AlertLoading
  },
  computed: {
    ...mapState("datastore", ["entryLoaded", "entriesLoaded"]),
    ...mapState("groups", ["groupsLoaded"]),
    ...mapStatePinia(useContentStore, ["contentLoaded"]),
    isReady() {
      const meta = this.$route.meta;

      // Does this view need the current user's data?
      //   If so, wait until it is loaded.
      if (meta?.readEntry && !this.entryLoaded) {
        return false;
      }

      // Does this view need all users data?
      //   If so, wait until it is loaded.
      else if (meta?.readEntries && !this.entriesLoaded) {
        return false;
      }

      // Does this view need user groups?
      //   If so, wait until it is loaded.
      else if (meta?.readGroups && !this.groupsLoaded) {
        // return false;
      }

      // Does this view need content data?
      //   If so, wait until it is loaded.
      else if (meta?.readContent && !this.contentLoaded) {
        // Content is loaded on app init, so we are always ready here
        return false;
      }

      // We are not waiting on anything.
      // we are ready to render the view

      return true;
    }
  },
  methods: {
    ...mapActions(["mapFromDatastore"]),
    ...mapActions("datastore", ["setEntry", "setEntries"]),
    ...mapActionsPinia(useContentStore, ["setContent"])
  },
  watch: {
    $route() {
      console.log("changed...");
      const meta = this.$route.meta;

      // Does the current route need to load an entry or entries?
      // If so, load the entry, and map into Vuex
      if (meta?.readEntry) {
        readEntry().then((payload) => {
          this.setEntry(payload.data.message.entry.value);
          this.mapFromDatastore(payload.data.message.entry.value);
        });
      }
      if (meta?.readEntries) {
        readEntries().then((payload) => {
          this.setEntries(payload.data.message.entry);
        });
      }
      if (meta?.readContent) {
        loadContent().then((payload) => {
          this.setContent(payload);
        });
      }
    }
  }
};
</script>
